import { isArray } from "../utils/objectPolyfill";

export const USE_ENUM = ["WORK", "HOME", "TEMP", "OLD", "USUAL", "OFFICIAL"];

export const ADDRESS_TYPE = ["POSTAL", "PHYSICAL", "BOTH"];

export const GENDER_ENUM = ["MALE", "FEMALE", "OTHER", "UNKNOWN"];

export const getAddress = location => {
  if (!location) return "";
  if (location === null) return "";
  let loc;
  if (isArray(location)) {
    loc = location[0];
  } else {
    loc = location;
  }
  let address = [];
  if (isArray(loc.address)) {
    address.push(loc.address.line[0]);
  } else {
    address.push(loc.address.line);
  }
  if (loc.address.city !== "") {
    address.push(loc.address.city);
  }
  if (loc.address.country !== "") {
    address.push(loc.country);
  }

  return address.join(", ");
};

export const getName = name => {
  if (!name) return "";

  // let nameArr = [];

  // if (name.prefix) nameArr.push(name.prefix);
  // if (name.given) nameArr.push(name.given);
  // if (name.family) nameArr.push(name.family);
  // if (name.suffix) nameArr.push(name.suffix);
  // return nameArr.join(' ');
  return name.text;
};

export const getNameWithoutPrefix = name => {
  if (!name) return "";

  let nameArr = [];
  if (name.given) nameArr.push(name.given);
  if (name.family) nameArr.push(name.family);
  return nameArr.join(" ");
};

export const getEmail = telecom => {
  // console.log('GET EMAIL', telecom);
  if (!telecom) return "";
  if (telecom === null) return "";
  if (!isArray(telecom)) return "";

  const arr = telecom.filter(t => t.system === "EMAIL");
  if (arr.length === 0) return "";
  return arr[0].value;
};

export const getPhone = telecom => {
  // console.log('GET PHONE', telecom);
  if (!telecom) return "";
  if (telecom === null) return "";
  if (!isArray(telecom)) return "";

  const arr = telecom.filter(t => t.system === "PHONE");
  if (arr.length === 0) return "";
  return arr[0].value;
};

export const personToFHIR = person => {
  let personFHIR = {};
  personFHIR.bio = person.bio || null;
  personFHIR.person = {
    name: {
      prefix: person.prefix || "",
      given: person.given || "",
      family: person.family || ""
    }
  };

  let text = [];

  if (person.prefix && person.prefix.trim !== "")
    text.push(person.prefix.trim());
  if (person.given && person.given.trim !== "") text.push(person.given.trim());
  if (person.family && person.family.trim !== "")
    text.push(person.family.trim());
  personFHIR.person.name.text = text.join(" ");

  if (person.phone !== "" || person.email !== "") {
    personFHIR.person.telecom = [];
  }
  if (person.email)
    personFHIR.person.telecom.push({
      system: "EMAIL",
      value: person.email,
      use: "WORK",
      rank: null,
      period: null
    });
  if (person.phone)
    personFHIR.person.telecom.push({
      system: "PHONE",
      countryCode: person.countryCode,
      value: person.phone,
      use: "WORK",
      rank: null,
      period: null
    });

  personFHIR.person.gender = person.gender;
  personFHIR.person.birthDate = person.birthDate;

  let address = person.address;
  if (address) {
    if (Array.isArray(address)) {
      let out = [];
      address.forEach(add => {
        let temp = processAddress(add);
        if (temp) {
          out.push(temp);
        }
      });
      personFHIR.person.addresses = out;
    } else {
      let temp = processAddress(address);
      personFHIR.person.addresses = temp ? [address] : [];
    }
  }

  if (person.loginUserId && person.password) {
    personFHIR.loginUserId = person.loginUserId;
    personFHIR.password = person.password;
  }
  return personFHIR;
};

function processAddress(address) {
  if (
    !address.line1 &&
    !address.line2 &&
    !address.room &&
    !address.floor &&
    !address.city &&
    !address.district &&
    !address.state &&
    !address.postalCode &&
    !address.country
  ) {
    return null;
  }

  let lines = [];
  lines[0] = address.line1;
  lines[1] = address.line2;

  address.line = lines;
  delete address.line1;
  delete address.line2;
  return address;
}
